import { useState } from 'react';
import { G } from '../theme';
import { FAQ } from '../data';
import FadeIn from './FadeIn';

export default function FAQSection() {
  const [open, setOpen] = useState(null);

  return (
    <section style={{ padding: '64px 24px', maxWidth: 760, margin: '0 auto' }}>
      <FadeIn>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
          <div style={{ width: 4, height: 32, background: G.g600, borderRadius: 2 }} />
          <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: '1.8rem', fontWeight: 700, margin: 0 }}>
            Questions fréquentes
          </h2>
        </div>
        <p style={{ color: G.gray6, fontSize: 15, marginBottom: 32, paddingLeft: 16 }}>
          Tout ce que vous devez savoir avant de vous inscrire
        </p>
      </FadeIn>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {FAQ.map((item, i) => {
          const isOpen = open === i;
          return (
            <FadeIn key={i} delay={i * 0.05}>
              <div
                style={{
                  background: '#fff',
                  border: `1.5px solid ${isOpen ? G.g600 : '#E4E4E0'}`,
                  borderRadius: 12,
                  overflow: 'hidden',
                  transition: 'border-color 0.2s',
                }}
              >
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  style={{
                    width: '100%',
                    background: 'none',
                    border: 'none',
                    padding: '18px 20px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    gap: 16,
                    fontFamily: "'DM Sans','Segoe UI',sans-serif",
                  }}
                >
                  <span style={{ fontSize: 15, fontWeight: 600, color: '#2C2C2A', textAlign: 'left', lineHeight: 1.4 }}>
                    {item.q}
                  </span>
                  <span style={{
                    flexShrink: 0,
                    width: 26,
                    height: 26,
                    borderRadius: '50%',
                    background: isOpen ? G.g700 : G.g100,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'background 0.2s',
                  }}>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path
                        d={isOpen ? 'M2 6h8' : 'M6 2v8M2 6h8'}
                        stroke={isOpen ? '#fff' : G.g700}
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </span>
                </button>
                {isOpen && (
                  <div style={{
                    padding: '0 20px 18px',
                    fontSize: 14,
                    color: G.gray6,
                    lineHeight: 1.75,
                    borderTop: `1px solid ${G.g100}`,
                    paddingTop: 14,
                  }}>
                    {item.a}
                  </div>
                )}
              </div>
            </FadeIn>
          );
        })}
      </div>
    </section>
  );
}
